module.exports = __webpack_public_path__ + "static/img/Coen-Hess.b67893a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Coen-Hess.jpg
// module id = WNax
// module chunks = 0